var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgNavTerms = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 14,
    height: 19,
    viewBox: "0 0 14 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "file-lines",
    clipPath: "url(#clip0_0_74)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M2.33333 1.78125H6.41667V5.04688C6.41667 6.52383 7.59062 7.71875 9.04167 7.71875H12.25V16.625C12.25 16.9516 11.9875 17.2188 11.6667 17.2188H2.33333C2.0125 17.2188 1.75 16.9516 1.75 16.625V2.375C1.75 2.04844 2.0125 1.78125 2.33333 1.78125ZM8.16667 2.51973L11.5245 5.9375H9.04167C8.55677 5.9375 8.16667 5.54043 8.16667 5.04688V2.51973ZM2.33333 0C1.04635 0 0 1.06504 0 2.375V16.625C0 17.935 1.04635 19 2.33333 19H11.6667C12.9536 19 14 17.935 14 16.625V6.9209C14 6.29004 13.7557 5.68516 13.3182 5.23984L8.84844 0.693945C8.41094 0.248633 7.82031 0 7.20052 0H2.33333ZM4.375 9.5C3.8901 9.5 3.5 9.89707 3.5 10.3906C3.5 10.8842 3.8901 11.2812 4.375 11.2812H9.625C10.1099 11.2812 10.5 10.8842 10.5 10.3906C10.5 9.89707 10.1099 9.5 9.625 9.5H4.375ZM4.375 13.0625C3.8901 13.0625 3.5 13.4596 3.5 13.9531C3.5 14.4467 3.8901 14.8438 4.375 14.8438H9.625C10.1099 14.8438 10.5 14.4467 10.5 13.9531C10.5 13.4596 10.1099 13.0625 9.625 13.0625H4.375Z",
    fill: "#850064"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_74"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 19,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgNavTerms);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/nav-terms.b6a9067df64844abaaaaa7af063b1937.svg";